import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import router from "./router";
import Breadcrumbs from "./components/bread_crumbs";
import { store } from "./store";
import VueFeather from "vue-feather";
import Toasted from "vue-toasted";
import SmartTable from "vuejs-smart-table";
import PxCard from "./components/Pxcard.vue";
import VueSweetalert2 from "vue-sweetalert2";
import axios from "axios";
import VueToast from "vue-toast-notification";

import numeral from "numeral";
import VueCurrencyInput from "vue-currency-input";
import VueBarcodeScanner from "vue-barcode-scanner";
import VueMoment from "vue-moment";
import moment from "moment";
import VeeValidate from "vee-validate";
import VueFab from "vue-float-action-button";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import VModal from "vue-js-modal";

import "vue-toast-notification/dist/theme-sugar.css";
import "vue-good-table/dist/vue-good-table.css";
import "@/assets/css/custom-good-table.css";

Vue.use(VModal);
Vue.use(VueFab, {
   iconType: "MaterialDesign",
});
Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);
require("moment/locale/es");

// Import Theme scss
import "./assets/scss/app.scss";

import "./registerServiceWorker";

Vue.use(VeeValidate, {
   inject: true,
   fieldsBagName: "veeFields",
   errorBagName: "veeErrors",
});

Vue.component(PxCard.name, PxCard);
Vue.component("Breadcrumbs", Breadcrumbs);

const pluginOptions = {
   globalOptions: { currency: "IDR" },
};
moment.locale("id");

Vue.use(VueMoment, { moment });
Vue.use(VueCurrencyInput, pluginOptions);
Vue.use(VueToast, {
   position: "top-right",
});
Vue.use(VueFeather);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.use(VueSweetalert2);
Vue.use(require("vue-faker"), { locale: "id_ID" });
Vue.use(require("vue-shortkey"), { prevent: ["input", "textarea"] });
Vue.use(Toasted, {
   iconPack: "fontawesome",
});
Vue.use(require("vue-chartist"));
Vue.use(VueBarcodeScanner);

//NUMERIK
numeral.register("locale", "id", {
   delimiters: {
      thousands: ".",
      decimal: ",",
   },
   abbreviations: {
      thousand: "k",
      million: "m",
      billion: "b",
      trillion: "t",
   },
   ordinal: function(number) {
      return number === 1 ? "er" : "ème";
   },
   currency: {
      symbol: "Rp",
   },
});
numeral.locale("id");
Vue.filter("formatNumber", function(value) {
   return numeral(value).format("0,0");
});
Vue.filter("formatRupiah", function(value) {
   return numeral(value).format("$ 0,0");
});

axios.interceptors.response.use(
   (response) => {
      return response;
   },
   (error) => {
      if (error.response.status == 401) {
         localStorage.removeItem("user");
         router.push("/login");
         return Promise.reject(error);
      }
      if (error.response.status == 403) {
         Vue.$toast.error("Tidak diizinkan");
         router.push("/");
         const msg =
            error.response.data.messages.error ||
            error.response.data.messages ||
            error.response.data ||
            error.response;

         return Promise.reject(msg);
      }

      try {
         const msg =
            error.response.data.messages.error ||
            error.response.data.messages ||
            error.response.data ||
            error.response;
         // console.log('onError => ' + JSON.stringify(msg))
         Vue.$toast.error(JSON.stringify(msg));
      } catch (e) {
         // console.log('onError.raw', e)
         Vue.$toast.error(JSON.stringify(error.response.request.statusText));
      }

      //  console.log(error.response.status);
      return Promise.reject(error);
   }
);

new Vue({
   router,
   store,
   render: (h) => h(App),
}).$mount("#app");
